import {
  WSElement,
  WSElementProps,
  WSFlexGrid,
  WSForm,
  WSSelect,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useFormContext } from "react-hook-form";

export type CardValues = {
  cardNumber: string;
  expYYYY: string;
  expMM: string;
  name: string;
  cvv?: string;
};

export const cardToValues = (card?: CardValues): CardValues => ({
  cardNumber: card?.cardNumber || "",
  expYYYY: card?.expYYYY || "",
  expMM: card?.expMM || "",
  name: card?.name || "",
  cvv: card?.cvv || ""
});

export const cardValuesToRequest = (values: CardValues): CardValues => ({
  cardNumber: values.cardNumber,
  expYYYY: values.expYYYY,
  expMM: values.expMM,
  name: values.name,
  cvv: values.cvv
});

type Props = {
  name: string;
  showCVV?: boolean;
} & WSElementProps;

export const CardField: React.FC<Props> = ({
  name,
  showCVV,
  ...elementProps
}) => {
  const { watch } = useFormContext();
  const cardValues = watch(name);

  return (
    <WSElement {...elementProps}>
      <WSForm.Field
        name={name + ".name"}
        label="Name on card"
        component={WSTextInput}
        mb="S"
      />

      <WSForm.Field
        name={name + ".cardNumber"}
        label="Card number"
        component={WSTextInput}
        componentProps={{
          formatOptions: {
            creditCard: true
          }
        }}
        mb="M"
      />

      <WSElement>
        <WSFlexGrid container spacing="S">
          <WSFlexGrid item mobile="12" tablet="6" desktop="4">
            <WSForm.Field
              name={name + ".expMM"}
              component={WSSelect}
              componentProps={{
                options: CARD_EXP_MONS,
                searchable: true
              }}
              label="Month"
            />
          </WSFlexGrid>
          <WSFlexGrid item mobile="12" tablet="6" desktop="4">
            <WSForm.Field
              name={name + ".expYYYY"}
              component={WSSelect}
              componentProps={{
                options: CARD_EXP_YEARS,
                searchable: true
              }}
              label="Year"
            />
          </WSFlexGrid>
          {showCVV && (
            <>
              <WSFlexGrid item mobile="12" tablet="12" desktop="4">
                <WSForm.Field
                  name={name + ".cvv"}
                  component={WSTextInput}
                  label="CVV"
                />
              </WSFlexGrid>
            </>
          )}
        </WSFlexGrid>
      </WSElement>
    </WSElement>
  );
};

export const CARD_EXP_MONS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12"
].map(s => ({
  value: s,
  label: s,
  searchText: s
}));

// ref: https://stackoverflow.com/questions/1575271/range-of-years-in-javascript-for-a-select-box
const CARD_EXP_YEAR_NOW = new Date().getFullYear();
const range = (start: number, stop: number, step: number) =>
  Array.from(
    { length: (stop - start) / step + 1 },
    (_, i) => `${start + i * step}`
  );
export const CARD_EXP_YEARS = range(
  CARD_EXP_YEAR_NOW,
  CARD_EXP_YEAR_NOW + 30,
  1
).map(s => ({
  value: s,
  label: s,
  searchText: s
}));
